import { currentBreakpoint } from '../lib/responsive.js';
import { elHTML } from '../config/vars';

class ResponsiveImagesManager {

  constructor() {
    const _that = this;

    this.eventHandlerRegistered = false;
    this.observer = window.IntersectionObserver ? new IntersectionObserver(this.onIntersection, {
      rootMargin: '100% 25%'
    }) : {
      observe(elem) {
        _that.onIntersection([{
          target: elem,
          isIntersecting: true,
          intersectionRatio: 1
        }], this);
      },
      unobserve(elem) {
        // noop
      }
    };
    this.observer.POLL_INTERVAL = 500; // enable polling for polyfilled browsers
  }

  setup(rootElement) {

    this.setupEventHandlers();
    rootElement = rootElement || document;
    rootElement.querySelectorAll('img.responsive-lazy-image:not([loading])').forEach(img => {

      if (!img.rimIsObserved) {

        this.observer.observe(img);
        img.rimIsObserved = true;
      }
    });
  }

  setupEventHandlers() {

    if (this.eventHandlerRegistered) {

      return;
    }
    document.body.addEventListener('load', this.imageLoadHandler, true);
    this.eventHandlerRegistered = true;
  }

  onIntersection(entries, observer) {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        observer.unobserve(entry.target);
        const img = entry.target;
        const srcset = img.getAttribute('data-srcset');
        const sizes = img.getAttribute('data-sizes');
        if ('sizes' in img && srcset && sizes) {

          img.srcset = img.srcset || srcset;
          img.sizes = img.sizes || sizes;
        } else {

          img.src = img.src || img.getAttribute('data-src');
        }
      }
    });
  }

  imageLoadHandler(e) {

    if (e.target.matches && e.target.matches('img.responsive-lazy-image')) {

      const img = e.target;
      const parent = e.target.parentNode;
      if (parent.classList.contains('lazy-loading-background-image') &&
        !img.classList.contains('hide@' + currentBreakpoint) && 
        !elHTML.classList.contains('is-player-mobile')) {

        if (img.style.objectFit !== undefined) {
          return;
        }

        const src = img.currentSrc || img.src;
        if (src) {

          parent.style.backgroundImage = 'url("' + src + '")';
        }
      } else {
        const canvas = parent.querySelector('canvas');
        if (canvas) {
          // const ctx = canvas.getContext('2d');
          // ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          parent.classList.add('image-loaded');
        }
      }
    }
  }
}

export default new ResponsiveImagesManager();
